import React, {useState, useEffect} from 'react';
import {Provider} from 'react-redux';
import configureStore from './store/configureStore';
import AppRouter from './routers/AppRouter';
import Loading from './components/Loading';
import {startGetMyInfo} from './actions/auth';
import {startFetchVehicleConfigs} from './actions/configs';
import {onLoginServiceCalls} from './actions/onLogin';
import 'normalize.css';

const store = configureStore()
function App() {
  const [authenticated, setAuthenticated] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      setAuthenticated(true);
    } else {
      store.dispatch(onLoginServiceCalls(token))
        .then(({
          success,
          error
        }) => {
          if (success) {
            setAuthenticated(true)
          } else {
            if (!!error.status){
              localStorage.removeItem('authToken');
            }
            setAuthenticated(true)
          }
        })
        .catch(() => {
          console.log("connection lost");
        })
    }
  }, [])

  return (
    <Provider store={store}>
      {authenticated ? (
        <AppRouter/>
      ):(
        <Loading/>
      )}
    </Provider>
  );
}

export default App;
